import { makeAutoObservable } from 'mobx';
import {AuthModel, AuthResponse} from "../model/auth-model"
import useStore from "../store/session-user-store"
import {HTTP_STATUS_CODE} from "../utils/UHttp";
import Cookies from "js-cookie";
import {useProfessionalViewModel} from "./professional/professional-view-model";
import i18next from 'i18next';
import companyViewModel from "./professional/company/company-view-model";



export class AuthViewModel {
    firstName: string = '';
    lastName: string = '';
    email: string = '';
    password: string = '';
    confirmPassword: string = '';
    acceptTerms: boolean = false;
    acceptPrivacy: boolean = false;
    errorMessage: string | null = null;
    message: string | null = null
    isLoading: boolean = false;
    private authModel: AuthModel;
    private professionalViewModel = useProfessionalViewModel()


    constructor() {
        makeAutoObservable(this);
        this.authModel = AuthModel.getInstance();
    }

    setFirstName = (firstName: string) => {
        this.firstName = firstName;
    };

    setLastName = (lastName: string) => {
        this.lastName = lastName;
    };

    setEmail = (email: string) => {
        this.email = email;
    };

    setPassword = (password: string) => {
        this.password = password;
    };

    setConfirmPassword = (confirmPassword: string) => {
        this.confirmPassword = confirmPassword;
    };

    setAcceptTerms = (value: boolean) => {
        this.acceptTerms = value;
    };

    setAcceptPrivacy = (value: boolean) => {
        this.acceptPrivacy = value;
    };

    setErrorMessage = (message: string | null) => {
        this.errorMessage = message;
    };

    setMessage = (message: string | null) => {
        this.message = message;
    };

    clearError = () => {
        this.errorMessage = null;
    };

    login = async (e: any) => {
        e.preventDefault()
        this.setErrorMessage("")
        try {
            this.isLoading = true;
            const result: AuthResponse = await this.authModel.handleLogin({
                email: this.email,
                password: this.password
            })
            if(result.status === HTTP_STATUS_CODE.OK){
                this.resetForm();
                useStore.setSession(result)

                await companyViewModel.handleGetAllCompaniesByCollaborator();
                await this.professionalViewModel.handleGetProfil()
                
                const currentLang = i18next.language;
                this.isLoading = false;
                window.location.href = `/${currentLang}/provider/dashboard`;
            } else {
                this.setErrorMessage(result.message)
            }
        } catch (error: any) {
            console.error(error.response.data.messagee);
        }
    };

    register = async (e: any) => {
        e.preventDefault()
        try {
            this.isLoading = true;
            const result = await this.authModel.handleRegister({
                firstName: this.firstName,
                lastName: this.lastName,
                email: this.email,
                password: this.password,
                confirmPassword: this.confirmPassword,
            })
            if(result.status === HTTP_STATUS_CODE.CREATED){
                this.resetForm();
                this.setMessage(result.message);

                setTimeout(() => {
                    const currentLang = i18next.language;
                    window.location.href = `/${currentLang}/login`;
                }, 4000);
            } else {
                this.setErrorMessage(result.message)
            }

        } catch (error: any) {
            console.error( "register",error.response.data.messagee)
        } finally {
            this.isLoading = false;
        }
    };

    logout = async () => {
        try {
            const result = await this.authModel.handleLogout()
            if(result.status === HTTP_STATUS_CODE.OK){
                Cookies.remove("MODESSID");
                Cookies.remove("MODESSID_REFRESH");
                const currentLang = i18next.language;
                window.location.href = `/${currentLang}/login`;
            }
        } catch (e){
            Cookies.remove("MODESSID");
            Cookies.remove("MODESSID_REFRESH");
            const currentLang = i18next.language;
            window.location.href = `/${currentLang}/login`;
        }
    }

    resetForm = () => {
        this.email = '';
        this.password = '';
        this.errorMessage = null;
        this.firstName = '';
        this.lastName = '';
        this.confirmPassword = '';
        this.acceptTerms = false;
    };
}

const authViewModel = new  AuthViewModel()

export const useAuthViewModel = () => {
    return authViewModel
}